import PropTypes from 'prop-types';
import { getValueAtPath } from '@/lib/utils';


export const Input = ({ id, form, type, placeholder, isRequired, className, label, ...props }) => {
    const hasError = form.touched[id] && form.errors[id];
    const inputClass = `form-control${hasError ? ' is-invalid' : ''}${className ? ` ${className}` : ''}`;
    const value = getValueAtPath(form.values, id);
    return (
        <>
            {label && (
                <label>{label} {isRequired && <sup className="required">*</sup>}</label>
            )}
            <input
                type={type}
                name={id}
                className={inputClass}
                value={value}
                onChange={form.handleChange}
                onBlur={form.handleBlur}
                placeholder={placeholder}
                id={id}
                required={isRequired}
                {...props}
            />
            {hasError && (
                <div id={`${id}Feedback`} className="invalid-feedback">
                    {form.errors[id]}
                </div>
            )}
        </>
    );
}
Input.propTypes = {
    id: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    isRequired: PropTypes.bool,
    className: PropTypes.string,
    label: PropTypes.string
};

Input.defaultProps = {
    type: 'text',
    placeholder: '',
    isRequired: false,
    className: '',
    label: ''
};